// extracted by mini-css-extract-plugin
export default {"linkMobile":"NavbarLinkMenu_linkMobile__V7DZK","linkContainer":"NavbarLinkMenu_linkContainer__ll4-j"};